/**
 * Button — кнопка во всю ширину.
 * variant: "primary" — заливка; "ghost" — контур.
 */
import type { ButtonHTMLAttributes } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "primary" | "ghost" };

export function Button({ variant = "primary", className = "", ...rest }: Props) {
  const base =
    "w-full rounded-2xl px-5 py-4 text-[16px] font-semibold transition active:scale-[0.99] disabled:opacity-50";
  const look =
    variant === "primary"
      ? "bg-brand text-surface-base shadow-lg shadow-brand/25 active:brightness-95"
      : "border border-white/10 text-white active:bg-white/5";
  return <button className={`${base} ${look} ${className}`} {...rest} />;
}